import { Certificate } from "../entities/certificate";
import { http } from "../http";

export type NewStatus = "reactivated" | "revoked" | "suspended";
export type StatusChangeReason =
  | "unspecified"
  | "keyCompromise"
  | "affiliationChanged"
  | "certificateHold"
  | "removeFromCRL";

export async function updateCertificate(
  certificateId: Certificate["certificate_id"],
  newCertificateStatus: NewStatus,
  reason: StatusChangeReason | undefined = undefined,
) {
  const updateCertificateResponse = await http.put<{
    code: string;
    message: string;
  }>(`certificates/${certificateId}`, {
    new_certificate_status: newCertificateStatus,
    reason: reason,
  });
  return updateCertificateResponse
}
